// extracted by mini-css-extract-plugin
module.exports = {"ColumnSelectionWrapper":"AfterTitleRow_ColumnSelectionWrapper__2cURV"};